/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProviderNonDetects } from './ProviderNonDetects';
import {
    ProviderNonDetectsFromJSON,
    ProviderNonDetectsFromJSONTyped,
    ProviderNonDetectsToJSON,
    ProviderNonDetectsToJSONTyped,
} from './ProviderNonDetects';

/**
 * Serializer for non-detect data grouped by quarter.
 * @export
 * @interface QuarterNonDetects
 */
export interface QuarterNonDetects {
    /**
     * Quarter description (e.g., '2024-Q1')
     * @type {string}
     * @memberof QuarterNonDetects
     */
    quarter: string;
    /**
     * Start date of the quarter
     * @type {Date}
     * @memberof QuarterNonDetects
     */
    startDate: Date;
    /**
     * End date of the quarter
     * @type {Date}
     * @memberof QuarterNonDetects
     */
    endDate: Date;
    /**
     * Non-detect data for each provider
     * @type {Array<ProviderNonDetects>}
     * @memberof QuarterNonDetects
     */
    data: Array<ProviderNonDetects>;
}

/**
 * Check if a given object implements the QuarterNonDetects interface.
 */
export function instanceOfQuarterNonDetects(value: object): value is QuarterNonDetects {
    if (!('quarter' in value) || value['quarter'] === undefined) return false;
    if ((!('startDate' in (value as Record<string, any>)) && !('start_date' in (value as Record<string, any>))) || ((value as Record<string, any>)['startDate'] === undefined && (value as Record<string, any>)['start_date'] === undefined)) return false;
    if ((!('endDate' in (value as Record<string, any>)) && !('end_date' in (value as Record<string, any>))) || ((value as Record<string, any>)['endDate'] === undefined && (value as Record<string, any>)['end_date'] === undefined)) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function QuarterNonDetectsFromJSON(json: any): QuarterNonDetects {
    return QuarterNonDetectsFromJSONTyped(json, false);
}

export function QuarterNonDetectsFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuarterNonDetects {
    if (json == null) {
        return json;
    }
    return {
        
        'quarter': json['quarter'],
        'startDate': (new Date(json['start_date'])),
        'endDate': (new Date(json['end_date'])),
        'data': ((json['data'] as Array<any>).map(ProviderNonDetectsFromJSON)),
    };
}

export function QuarterNonDetectsToJSON(json: any): QuarterNonDetects {
    return QuarterNonDetectsToJSONTyped(json, false);
}

export function QuarterNonDetectsToJSONTyped(value?: QuarterNonDetects | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quarter': value['quarter'],
        'start_date': value['startDate'].toISOString().substring(0,10),
        'end_date': value['endDate'].toISOString().substring(0,10),
        'data': ((value['data'] as Array<any>).map(ProviderNonDetectsToJSON)),
    };
}

